module.exports = __webpack_public_path__ + "62f0e7f7e2e0e23439d68cc384ce0298.pdf";